<!--
 * @Author: tjessie
 * @Date: 2025-05-13 16:19:29
 * @LastEditors: tjessie
 * @LastEditTime: 2025-06-10 13:23:49
 * @Description: file content
 * @FilePath: \juqu-pandakt\src\views\pc\news.vue
-->
<template>
  <div>
    <Bj :bjData="bjData" />
    <div class="myTitle">公司简介</div>
    <div class="text">
      <div>
        湖南米啦科技有限公司，于2025年在长沙成立，旗下推出创新教育平台 熊猫云学堂 ——
        您专属的新办公区学习伙伴！平台专注为热爱国风艺术、音乐戏剧、健康生活、科技探索的学习者，提供精心涉及的系统化课程。我们以先进技术为支撑，通过智能学习路径规划帮助许愿匹配兴趣方向，借助沉浸式学习场景提升学习体验（如辅助书法练习、虚拟音乐室），并建立数字化成长档案追踪学习成果。平台现已上线涵盖书画、戏曲、健身、编程等领域的百余门课程，每门均由专业教研团队匠心研发，聚焦「让兴趣照进生活」的核心目标。在这里，你将通过科学的课程体系发现热爱，在愉悦的学习过程中提升技能，最终让兴趣成功为丰富生活的持久养分。熊猫云学堂，与您共同探索更精彩的人生维度！
      </div>
    </div>
    <!-- <Develop /> -->
    <img class="main vision" src="../../assets/pc/vision.png" alt="" />
  </div>
</template>
<script>
import Bj from "@/components/pc/bj";
// import Develop from '@/components/pc/develop.vue'
export default {
  components: {
    Bj,
    // Develop,
  },
  data() {
    return {
      bjData: {
        imgUrl: "https://qn.juquedu.com/news.png",
        title: "米啦科技",
        minTitle: "为互联网学习用户提供真正优质的数字化学习产品",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.text {
  width: 1198px;
  margin: auto;
  color: #333333;
  font-size: 18px;
  margin-top: 48px;
  line-height: 42px;
  text-indent: 2em;
  margin-bottom: 100px;
}
.vision {
  margin-bottom: 100px;
}
</style>
